export default __webpack_public_path__ + "images/Ramen.51ecb4.jpg";